<template>
  <div>
    <pbas-data-table
      v-if="provider"
      :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      fileNamePrefix="notes"
      identifier="member_notes"
      :floatActions="tableActions"
      :rowActions="rowActions"
      @error="error=$event"
      :showSelect="false"
    ></pbas-data-table>
    <v-container fluid grid-list-md v-else>
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showForm" scrollable max-width="1000px" persistent>
      <member-notes-form
        :note="currentNote"
        @close="showForm = false"
        @save="
          showForm = false;
          loadData();
        "
      ></member-notes-form>
    </v-dialog>
    <v-dialog v-model="showArchive" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ $t("views.balanceview.archive_note") }}
        </v-card-title>
        <v-card-text>
          {{ $t("components.membernotestable.warning_text") }}
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" md="8">
                  <no-autocomplete-textfield
                    v-model="reason"
                    :label="$t('components.membernotestable.comment')"
                    autocomplete="off"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="showArchive = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="
              showArchive = false;
              archiveNote();
            "
            :loading="archiving"
          >
            {{ $t("globals.continue") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDelete" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ $t("components.membernotestable.delete_title") }}
        </v-card-title>
        <v-card-text>
          {{ $t("components.membernotestable.delete_warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="showDelete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="
              showDelete = false;
              deleteNote();
            "
            :loading="archiving"
          >
            {{ $t("globals.continue") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="showNote" max-width="700px" scrollable>
      <v-card v-if="currentNote">
        <v-card-title>
          {{ currentNote.Title }}
        </v-card-title>
        <v-divider />
        <v-card-text>
          <div style="padding:10px 0;" v-html="currentNote.Text"></div>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <div v-if="!showActive" style="padding:10px 0;" v-html="'Comment: '+currentNote.ArchiveReason"></div>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn text @click="showNote = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import InMemoryMemberNotesHeaders from "@/headers/MemberNotes";
import MemberNotesForm from "./MemberNotesForm";
import ErrorHandler from "../components/ErrorHandler";
import { InMemoryHeader, InMemoryString } from "pbas-vue-components";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";

export default {
  name: "member-notes-table",
  props: {
    memberId: String,
    showActive: {
      default: true,
    },
  },
  components: {
    MemberNotesForm,
    ErrorHandler,
    NoAutocompleteTextfield
  },
  data() {
    return {
      valid: true,
      reason: null,
      showNote: false,
      archiving: false,
      showArchive: false,
      showDelete: false,
      provider: null,
      rowActions: [
        {
          title: "views.dashboard.view",
          name: "view",
          icon: "visibility",
          handler: (item) => {
            this.currentNote = item;
            this.showNote = true;
          },
        },
        // {
        //   title: "globals.edit",
        //   name: "edit",
        //   icon: "edit",
        //   handler: (item) => {
        //     this.currentNote = item;
        //     this.showForm = true;
        //   },
        //   visible: (item) => item.IsActive,
        // },
        {
          title: "views.billingwizard.archive",
          name: "archive",
          icon: "archive",
          handler: (item) => {
            this.currentNote = item;
            this.showArchive = true;
          },
          visible: (item) => item.IsActive,
        },
        {
          title: "globals.delete",
          name: "delete",
          icon: "delete",
          handler: (item) => {
            this.currentNote = item;
            this.showDelete = true;
          },
          visible: () => this.role.indexOf('Broker Plan Manager') > -1,
        },
      ],
      tableActions: [
        {
          text: "globals.add_new",
          color: this.$vuetify.theme.themes.light.success,
          name: "add",
          icon: "add",
          handler: () => {
            this.currentNote = {
              Title: "",
              Text: "",
              Category: null,
              MemberIdentityId: this.memberId,
              IsActive: true,
            };
            this.showForm = true;
          },
        },
      ],
      showForm: false,
      selectActions: [],
      currentNote: null,
      error: null,
    };
  },
  methods: {
    ...mapActions("plansMembers", ["archiveMemberNote", "getMemberInfo", "deleteMemberNote"]),
    async loadData() {
      this.provider = null;
      if (this.memberId) {
        const member = (await this.getMemberInfo({
          planIdentityId: this.selectedPlan.Id,
          odataQuery:
            "$expand=Notes($orderby=Timestamp desc;$filter=IsActive eq " +
            (this.showActive ? "true" : "false") +
            ")",
          memberIdentityId: this.memberId,
        })).data;
        const headers = this.showActive
          ? InMemoryMemberNotesHeaders
          : InMemoryMemberNotesHeaders.concat([
              new InMemoryHeader({
                title: "Comment",
                type: new InMemoryString("ArchiveReason"),
                version: 1,
              }),
            ]);
        this.provider = new InMemoryProvider(member.Notes, headers);
      }
      this.$emit("load-data");
    },

    async archiveNote() {
      this.archiving = true;
      this.error = null;
      try {
        const item = { ...this.currentNote };
        item.IsActive = false;
        await this.archiveMemberNote({
          planIdentityId: this.selectedPlan.Id,
          memberId: item.MemberIdentityId,
          payload: {
            MemberIdentityId: item.MemberIdentityId,
            NoteId: item.Id,
            Reason: this.reason,
          },
        });
      } catch (e) {
        console.error(e);
        this.error = e;
      }
      await this.loadData();
    },

    async deleteNote() {
      this.archiving = true;
      this.error = null;
      try {
        const item = { ...this.currentNote };
        await this.deleteMemberNote({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: item.MemberIdentityId,
          payload: {
            MemberIdentityId: item.MemberIdentityId,
            NoteId: item.Id
          },
        });
      } catch (e) {
        console.error(e);
        this.error = e;
      }
      await this.loadData();
    },
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", [ "role"]),
  },
  watch: {
    memberId: {
      immediate: true,
      handler: async function() {
        await this.loadData();
      },
    },
  },
  // mounted() {
  //   console.log("id", this.memberId);
  // },
};
</script>
